export default {
    payload:{
        currentDay:0,
        lastDay:0,
    }
}